function updateCheckoutPrice() {
  var items = document.querySelectorAll('drawer-item');
  if (items.length === 0) return;
  var allTurbo = Array.from(items).every(function(item) {
    return item.querySelector('a[href*="turbosilence"]');
  });
  var btn = document.querySelector('.cart-drawer__checkoutButtons-normal span');
  if (btn) btn.style.display = allTurbo ? 'none' : '';
}

// 监听购物车抽屉 DOM 变化
var observer = new MutationObserver(updateCheckoutPrice);
document.addEventListener('DOMContentLoaded', function() {
  var target = document.querySelector('cart-drawer-component');
  if (target) observer.observe(target, { childList: true, subtree: true });
  updateCheckoutPrice();
});

function updateCartPagePrice() {
  var subtotal = document.querySelector('.cart-total.price');
  if (subtotal) subtotal.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', updateCartPagePrice);
setTimeout(updateCartPagePrice, 500);
setTimeout(updateCartPagePrice, 1500);

// 购物车页面：隐藏 TurboSilence 行项目价格
function updateCartPageItemPrice() {
  document.querySelectorAll('drawer-item').forEach(function(item) {
    var link = item.querySelector('a[href*="turbosilence"]');
    var priceEls = item.querySelectorAll('[class*="price"]');
    priceEls.forEach(function(el) {
      el.style.display = link ? 'none' : '';
    });
  });
}

document.addEventListener('DOMContentLoaded', updateCartPageItemPrice);
setTimeout(updateCartPageItemPrice, 500);
setTimeout(updateCartPageItemPrice, 1500);
setTimeout(updateCartPagePrice, 500);
setTimeout(updateCartPagePrice, 1500);

// Afterpay messaging dynamic price update
document.addEventListener('DOMContentLoaded', function() {
  function updateAfterpayMessaging(priceInCents) {
    var installment = priceInCents / 4;
    var formatted = '$' + (installment / 100).toFixed(2);
    var el = document.querySelector('.afterpay-messaging strong');
    if (el) el.textContent = formatted;
  }
  document.addEventListener('variant:changed', function(e) {
    if (e.detail && e.detail.variant && e.detail.variant.price) {
      updateAfterpayMessaging(e.detail.variant.price);
    }
  });
});

// Afterpay + Klarna collapsible panel
// Afterpay + Klarna 折叠逻辑 + 价格初始化
function initApKlarnaPanel() {
  var toggle = document.querySelector('.ap-toggle');
  var klarnaRow = document.querySelector('.klarna-row');
  if (toggle && klarnaRow) {
    var expanded = false;
    toggle.addEventListener('click', function() {
      expanded = !expanded;
      klarnaRow.style.display = expanded ? 'block' : 'none';
      toggle.innerHTML = expanded ? '&#8963;' : '&#8964;';
    });
  }
  try {
    var priceInCents = ShopifyAnalytics.meta.product.variants[0].price;
    var el = document.querySelector('.ap-installment');
    if (el) el.textContent = '$' + (priceInCents / 4 / 100).toFixed(2);
    var klarnaEl = document.querySelector('.klarna-installment');
    if (klarnaEl) klarnaEl.textContent = '$' + (priceInCents / 4 / 100).toFixed(2);
  } catch(e) {}
}

// 多重保障确保执行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApKlarnaPanel);
} else {
  initApKlarnaPanel();
}
setTimeout(initApKlarnaPanel, 300);
setTimeout(initApKlarnaPanel, 800);

document.addEventListener('variant:changed', function(e) {
  if (e.detail && e.detail.variant) {
    var el = document.querySelector('.ap-installment');
    if (el) el.textContent = '$' + (e.detail.variant.price / 100 / 4).toFixed(2);
    var klarnaEl = document.querySelector('.klarna-installment');
    if (klarnaEl) klarnaEl.textContent = '$' + (e.detail.variant.price / 100 / 4).toFixed(2);
  }
});
// =============================================
// Product Thumbnail Height Fix - Desktop
// =============================================
(function() {
  function fixThumbnailHeight() {
    // 只在桌面端执行
    if (window.innerWidth < 750) return;

    const mainSlider = document.querySelector(
      '.product-slider--thumbnail-left .swiper-container[main-slider]'
    );
    const thumbContainer = document.querySelector(
      '.product-slider--thumbnail-left .swiper-thumbnails .swiper-container[thumbnail-slider]'
    );

    if (!mainSlider || !thumbContainer) return;

    const mainHeight = mainSlider.offsetHeight;
    if (mainHeight > 0) {
      thumbContainer.style.maxHeight = mainHeight + 'px';
      thumbContainer.style.overflowY = 'hidden';
      thumbContainer.style.overflowX = 'hidden';
    }
  }

  // 页面加载后执行
  function init() {
    // 延迟执行等待 Swiper 初始化完成
    setTimeout(fixThumbnailHeight, 300);
    setTimeout(fixThumbnailHeight, 800);
    setTimeout(fixThumbnailHeight, 1500);

    // 窗口缩放时重新计算
    window.addEventListener('resize', fixThumbnailHeight);

    // 监听变体切换（图片变化时重新计算）
    document.addEventListener('variant:change', function() {
      setTimeout(fixThumbnailHeight, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();